var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeContainer"},_vm._l((_vm.elements),function(data){return _c('div',{key:data.title},[_c('SettingsComponent',{attrs:{"data":data}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }